import * as Api from '@/api';
import { mapState } from 'vuex';
import tableHeaderName from '@/utils/table_header_name';
import { _restApiDataFormatting } from '@/utils/_function.js';

export default {
  name: 'DomainsDetail',
  data() {
    return {
      domainDetail: null,
      domainId: null,
      fields: tableHeaderName.historyFields
    };
  },
  mounted() {
    this.getDomainDetailData();
  },
  computed: {
    ...mapState({
      authUser: state => state.authUser
    }),
    getDomainDetailLoaderStatus() {
      return this.$store.getters.LOADERS.includes('domain');
    }
  },
  methods: {
    getDomainDetailData() {
      this.domainId = this.$route.params.id;
      const blocker = 'domain';

      Api.getDomainDetailData(this.domainId, blocker)
        .then((response) => {
          if (response) {
            this.domainDetail = _restApiDataFormatting(response);
          }
        })
        .catch((error) => {
          if (error) {
            this.$rollbar.error(error);
          }
          this.$toastr('error', this.$t('commonMessage.requestError'), 'Ошибка');
        });
    }
  }
};
